import React from "react";

export default function PrivacyPage() {
  return (
    <main className="max-w-[860px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
      <div className="wk-eyebrow mb-5">Privacidad</div>
      <h1 className="text-[42px] lg:text-[56px] font-extrabold tracking-hero leading-[1.05]" style={{ color: "#1E1924" }} data-testid="privacy-title">
        Datos de la guía
      </h1>
      <div className="mt-10 space-y-7 text-[16px] leading-[1.7]" style={{ color: "#1E1924" }}>
        <p data-testid="privacy-data-text">
          Guardamos nombre, apellidos, email, WhatsApp y el canal elegido para recibir la guía.
        </p>
        <p data-testid="privacy-purpose-text">
          Usamos estos datos para enviar la guía y, solo si lo marcas, consejos y ofertas de We·Spik.
        </p>
        <p data-testid="privacy-retention-text">
          Conservamos los datos hasta que pidas la baja.
        </p>
        <p data-testid="privacy-unsubscribe-text">
          Para darte de baja, escribe a <a className="underline" href="mailto:toni@wer2ecosystem.com">toni@wer2ecosystem.com</a>. Responsable: Antonio Gimeno Calvo.
        </p>
      </div>
    </main>
  );
}